var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.002,
    height: 18.001,
    viewBox: "0 0 18.002 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_236",
    "data-name": "Union 236",
    d: "M16970.566,10595.962a3.634,3.634,0,0,1-3.666-3.594v-10.776a3.634,3.634,0,0,1,3.666-3.593l10.67.038a3.635,3.635,0,0,1,3.666,3.594v10.775a3.635,3.635,0,0,1-3.666,3.594Zm-2.2-14.37v10.776a2.182,2.182,0,0,0,2.2,2.157l10.67.038a2.183,2.183,0,0,0,2.2-2.157v-10.775a2.183,2.183,0,0,0-2.2-2.157l-10.67-.034A2.179,2.179,0,0,0,16968.367,10581.592Zm5.434,11.207a.9.9,0,0,1,0-1.8h4.2a.9.9,0,1,1,0,1.8Z",
    transform: "translate(-16966.9 -10577.999)",
    fill: "#a2a3a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDevice);
export default __webpack_public_path__ + "static/media/menu_device.05948f0a993514076842c70dd9e0c68a.svg";
export { ForwardRef as ReactComponent };